import Button from 'components/Button';
import React, { ReactElement, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from 'store/rootReducer';
import styled from 'styled-components';
import { WarningInfo } from 'styles/containers';

import Modal from '../Modal';
import styles from './NotFoundRoute.module.scss';

type Props = {
  dashboard?: boolean;
};

function NotFoundRoute({ dashboard }: Props): ReactElement {
  const { sessionKey } = useSelector((state: RootState) => state.account);
  const navigate = useNavigate();

  useEffect(() => {
    // redirect to login page if session key expired
    if (!sessionKey) navigate('/');
  }, [sessionKey]);

  function handleNotFoundNavigation(): void {
    navigate(dashboard ? '/dashboard/map' : '/');
  }

  return dashboard ? (
    <Main>
      <h2>Whoops, it seems like this page doesn&apos;t exist.</h2>
      <Button onClick={handleNotFoundNavigation}>Return to Dashboard</Button>
    </Main>
  ) : (
    <div className={styles.defaultBackground}>
      <Modal title={'Page Not Found'}>
        <WarningInfo>Whoops, it seems like this page doesn&apos;t exist.</WarningInfo>
        <Button onClick={handleNotFoundNavigation}>Return to Main Page</Button>
      </Modal>
    </div>
  );
}

export default NotFoundRoute;

const Main = styled.div`
  background: white;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  margin: 20px;
  height: 400px;
  border-radius: 4px;
  h2 {
    font-size: 20px;
  }
  button {
    margin-top: 20px;
  }
`;
